<template>
  <div class="menu-container" ref="menuContainer" @click="toggleMenu">{{ popupText }}
    <div v-if="isMenuVisible" class="dropdown-menu">
      <div class="triangle"></div>
      <!-- 小三角 -->
      <ul>
        
        <li v-for="(item, index) in menuItems" :key = index @click="selectItem(item.returnmsg)">{{item.menutext}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import EventBus from '@/util/eventBus'
export default {
  data() {
    return {
      isMenuVisible: false,
    };
  },
  props: {
    popupText: {
      type: String,
      default: "...", // 默认文本
    },
    menuItems: {
      type:Array,
      default: () => {
        return [{ menutext:"保存"  },{ menutext:"取消"  },];
      },
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
      if (this.isMenuVisible) {  
        this.adjustMenuPosition();  
      }  
    },
    adjustMenuPosition() {  
    this.$nextTick(() => {  
        const menuContainer = this.$refs.menuContainer;  
        const dropdownMenu = menuContainer.querySelector('.dropdown-menu');  

        // 获取菜单容器和下拉菜单的矩形信息  
        const containerRect = menuContainer.getBoundingClientRect();  
        // const menuRect = dropdownMenu.getBoundingClientRect();  
        const viewportWidth = window.innerWidth;  
        // console.log(viewportWidth);  
        
        // 默认菜单位置为 0，即相对于容器对齐  
        // let newPosition = '0%';  
        
        // 计算下拉菜单右侧是否超出视口  
        if (containerRect.x + 70 > viewportWidth) {  
            const overflow = viewportWidth - containerRect.x +20 ;  
            // console.log(containerRect, overflow);  
            // console.log(overflow)
            // 计算新的左侧位置，向左移动，使用 overflow 作为位移  
            let translateX = -overflow; // 向左移动的位移  
            
            // 还需检查是否移动后的菜单超出左边界，如果超出则重置为 0 换言之  
            // 确保下拉菜单不超出父容器  
            // if (containerRect.left + translateX < 0) {  
            //     translateX = -containerRect.left; // 如果超出，则将菜单位置重置为0  
            // }  

            // 应用计算出的偏移量到菜单样式  
            dropdownMenu.style.transform = `translateX(${translateX}px)`;  
        } else {  
            // 如果没有超出，保持默认位置  
            dropdownMenu.style.transform = 'translateX(0)';  
        }  
    });  
},
    selectItem(item) {
//         let width = window.innerWidth;  
// let height = window.innerHeight;  
// console.log(`Width: ${width}, Height: ${height}`);  
      console.log(item);

      EventBus.emit('popupClick', item);  
   
      this.isMenuVisible = false; // 选择项后关闭菜单
    },
    handleClickOutside(event) {
      const menuContainer = this.$refs.menuContainer;

      // 检查点击是否发生在菜单外部
      if (menuContainer && !menuContainer.contains(event.target)) {
        this.isMenuVisible = false; // 收缩菜单
      }
    },
  },
  mounted() {
    console.log("监听事件");
    document.addEventListener("click", this.handleClickOutside); // 添加事件监听
  },
  beforeUnmount() {
    console.log("清理事件监听");
    document.removeEventListener("click", this.handleClickOutside); // 清理事件监听
  },
};
</script>

<style scoped lang="less">
.menu-container {
  position: relative; /*  设置为相对定位以定位下拉菜单 */
}
.dropdown-menu {  
  position: absolute; /* 使用绝对定位 */  
  width: 70px;  
  text-align: center;  
  top: 150px; /* 固定 Y 坐标，150px 距离顶部 */  
  left: 50px; /* 固定 X 坐标，50px 距离左侧 */  
  background-color: white; /* 背景颜色 */  
  border: 1px solid #ccc; /* 边框 */  
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 阴影效果 */  
  z-index: 1000; /* 确保下拉菜单在其它元素的上方 */  
}  
.dropdown-menu {  
  position: absolute; /* 使用绝对定位 */  
  width: 70px;  
  text-align: center;  
  top: 100%; /* 位于按钮下方 */  
  left: 0; /* 左对齐 */  
  /* 使用 calc() 计算水平偏移量 */  
  transform: translateX(calc(-10% - 140px));   
  background-color: white; /* 背景颜色 */  
  border: 1px solid #ccc; /* 边框 */  
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 阴影效果 */  
  z-index: 1000; /* 确保下拉菜单在其它元素的上方 */  
} 
.dropdown-menu ul {
  list-style: none; /* 去掉列表标志 */
  padding: 0; /* 取消内边距 */
  margin: 0; /* 取消外边距 */
}

.dropdown-menu li {
  padding: 8px 5px; /* 内边距 */
  cursor: pointer; /* 鼠标上显示为手型 */
}

.dropdown-menu li:hover {
  background-color: #f0f0f0; /* 鼠标悬 hover 效果 */
}

.triangle {
  position: absolute;
  bottom: 100%; /* 在下拉菜单外部 */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white; /* 小三角的颜色需与菜单背景色相同 */
  border: 5px solid #f0f0f0;; /* 小三角的轮廓颜色 */
}
</style>
